<template>
  <nav-bar class="navbarArea"></nav-bar>
  <RouterView />
  
</template>

<script>
import NavBar from './components/NavBarView.vue';

export default {
  name: 'App',
  components: {
    NavBar,
  },

  mounted() {
    const setFontSize = () => {
      let windowWidth = window.$(document).width()
      let fontSize
      if (windowWidth >= 768) {
        fontSize = Math.ceil(windowWidth / 1920 * 16)
      } else {
        fontSize = Math.ceil(windowWidth / 375 * 16)
      }
      window.$(":root").css("font-size", `${fontSize}px`)
    }
    setFontSize()
    window.addEventListener('resize', setFontSize)
  },
}
</script>

<style lang="scss">
html, body, #app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  width: 100%;
  height: 100%;
  font-family: "Roboto", sans-serif;
}

.navbarArea {
  z-index: 100;
  position: fixed;
  top: 0;
}
</style>
